<template>
  <div>
    <div class="d-flex" :class="isOdd ? 'ODD': 'EVEN'">
      <div v-if="isMobile" class="d-flex TEXT p-y-2 p-l-2 p-l-3:t fd-column">
        <div class="d-flex p-b-1">
          <div class="text-bold LABEL">
            Job ID
          </div>
          <div class="text-bold link">
            <a @click.prevent="openHistoryJobModal">
              {{ job.user_friendly_identifier }}
            </a>
          </div>
        </div>
        <div class="d-flex p-b-1">
          <div class="text-bold LABEL">
            Customer Name
          </div>
          <div>
            {{ job.user.first_name }} {{ job.user.last_name }}
          </div>
        </div>
        <div class="d-flex">
          <div v-html="selectedLabel" class="text-bold LABEL">
          </div>
          <div v-html="value">

          </div>
        </div>
      </div>
      <div v-else class="TEXT VALUE ">
        <div v-if="hasJobId">
          <div class="p-l-2 text-bold">
            <a @click.prevent="openHistoryJobModal">
              {{ job.user_friendly_identifier }}
            </a>
          </div>
        </div>
        <div v-else>
          {{value}}
        </div>
      </div>
    </div>
    <history-job-modal
        v-if="isHistoryJobModalOpen"
        @close="close"
        :job="job"/>
  </div>
</template>

<script>

import { format } from 'date-fns';
import capitalize from '@/filters/capitalize';
import HistoryJobModal from './HistoryJobModal';


export default {
  name: 'history-item',
  components: { HistoryJobModal },
  props: {
    index: {
      type: Number,
      required: true,
    },
    job: {
      type: Object,
      required: true,
    },
    property: {
      type: String,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isHistoryJobModalOpen: false,
    };
  },
  computed: {
    jobId () {
      return this.job.order_hash;
    },
    value () {
      switch (this.property) {
        case 'id': {
          return this.job.user_friendly_identifier;
        }
        case 'date': {
          return this.isMobile
            ? `${format(new Date(this.job.time_created), 'MMM d, yyyy /')}<br />${format(new Date(this.job.time_created), 'h:mma')}`
            : format(new Date(this.job.time_created), 'MMM d, yyyy / h:mma');
        }
        case 'name': {
          return `${this.job.user.first_name} ${this.job.user.last_name}`;
        }
        case 'service_name': {
          return this.job.work_order.service_name;
        }
        case 'cost': {
          return `${Math.abs(this.job.lead_cost)} points`;
        }
        case 'your_action': {
          return capitalize(this.job.your_action);
        }
        case 'current_status': {
          return capitalize(this.job.current_status);
        }
        default:
      }
    },
    selectedLabel () {
      switch (this.property) {
        case 'date': {
          return 'Recieved Date /<br />Time';
        }
        case 'service_name': {
          return 'Service Type';
        }
        case 'your_action': {
          return 'Job Status';
        }
        case 'current_status': {
          return 'Current Status';
        }
        default:
      }
    },
    isOdd () {
      return this.index % 2 === 1;
    },
    hasJobId () {
      return this.property === 'id';
    },
  },
  methods: {
    openHistoryJobModal () {
      this.$events.$emit(this.$events.PERFORMANCE_HISTORY_MODAL_CLICK, {
        jobId: this.jobId,
      });
      this.isHistoryJobModalOpen = true;
    },
    close () {
      this.isHistoryJobModalOpen = false;
    },
    handleClick (event) {
      this.$events.$emit(this.$events.URL_CLICK, { toURL: event.target.href });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

  .ODD {
    background-color: white;
  }
  .EVEN {
    background-color: $color-gray20;
  }
  .LABEL {
    min-width: calc(95vw /2);
    margin-right: $unit;
  }
  .TEXT {
    font-size: 1.75 * $unit;
  }
  .VALUE {
    margin-top: 2 * $unit;
    margin-right: .5 * $unit;
    word-wrap: break-word;
    height: 5 * $unit;
  }
  .CHECK {
    padding-top: $unit * 0.5;
  }

</style>
